module.exports = __webpack_public_path__ + "img/la_consolidada.cfbde1bf.png";